<template>
  <div class="home">
    <Banner height="600px" />
    <div class="main-content" style="padding-bottom: 0">
      <div class="container title">
        <h3>瀚林愿教育AI成长平台</h3>
        <p class="small-text">HanLinYuan Educational AI Growth Platform</p>
      </div>
      <div class="blue-bg" :class="{'about-col': platformIntroduction.contentForm === 0}">
        <div class="container">
          <div class="about">
            <div class="about-left">
              <div v-for="(item,index) in platformIntroduction.contentList" :key="index" class="about-item" :class="{active: index === activeItem}" @click="handleActiveItem(index)">{{item.tabName}}</div>
            </div>
            <div class="about-right">
              <img v-if="fileObj.fileType === 'img'" :src="fileObj.fileUrl" alt="about" class="about-img" />
              <div v-if="fileObj.fileType === 'video'" class="about-content">
                <video :src="fileObj.fileUrl" controls width="100%" height="100%"></video>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="main-content container">
      <div class="title">
        <h3>合作案例</h3>
        <p class="small-text">Collaboration Cases</p>
      </div>
      <div class="container case-list">
        <div v-for="(item, index) in caseList" :key="index" class="case-item" :class="{active: index === caseActiveIndex}">
          <img :src="item.imgUrl" alt="case" class="case-img" />
          <div class="case-content" :class="item.bgColor" @click="caseActiveIndex = index">
            <div class="case-content-main">
              <div>
                <p><img :src="item.icon" alt="case" class="case-icon" /></p>
                <p class="case-name">{{item.name}}</p>
              </div>
              <div class="more"><NuxtLink :to="`/detail?type=case&id=${item.id}`"><span class="case-more-btn"> <el-icon size="30"><Right /></el-icon> </span></NuxtLink></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="main-content blue-bg">
      <Team />
      <!-- <div class="title">
        <h3>专家团队</h3>
        <p class="small-text">Expert team</p>
      </div>
      <div class="container team-list">
        <div v-for="(item, index) in teamList" :key="index" class="team-item" :class="item.bgColor">
          <img :src="item.avatar" alt="" class="team-avatar" />
           <p class="team-position">{{item.position}}</p>
           <p class="team-name">{{item.name}}</p>
           <p v-for="(citem, index) in item.description.split('|')" :key="index" class="team-content">{{citem}}</p>
        </div>
      </div> -->
    </div>
    <div class="main-content" style="padding-bottom: 0">
      <Honor />
    </div>
    <div class="main-content blue-bg">
      <div class="title">
        <h3>最新资讯动态</h3>
        <p class="small-text">latest news</p>
      </div>
      <div class="container news">
        <div v-for="(item, index) in newsData" :key="index" class="news-item-box">
          <div class="news-type" :class="item.bgColor">
            <div class="news-type-left">
              <p class="news-type-title">{{item.title}}</p>
              <p class="news-type-enTitle">{{item.enTitle}}</p>
            </div>
          </div>
          <div class="news-list">
            <a v-for="cItem in item.list" :key="cItem.id" :href="`detail?type=news&id=${cItem.id}`" class="news-item">
              <span class="news-time">{{cItem.updateTime.split(' ')[0]}}</span>
              <span class="news-title">{{cItem.title}}</span>
            </a>
          </div>
          <div v-if="item.list?.length > 0" class="news-more"> <NuxtLink :to="`/news?type=${item.type}`"><span class="news-more-btn"> <el-icon size="30"><Right /></el-icon> </span></NuxtLink></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from 'vue'
import { ElCarousel, ElCarouselItem, ElIcon } from 'element-plus'
import { Right } from '@element-plus/icons-vue'
import { useHttpApi } from '~/composables/useApi'
import { usePageSeo } from '~/composables/useSeo'
import Banner from './compontents/banner.vue'
import Team from './compontents/team.vue'
import Honor from './compontents/honor.vue'
import caseIcon01 from '@/assets/images/case/icon01.png'
import caseIcon02 from '@/assets/images/case/icon02.png'
import caseIcon03 from '@/assets/images/case/icon03.png'
import caseIcon04 from '@/assets/images/case/icon04.png'


usePageSeo({
  title: '瀚易特信息技术股份有限公司',
  description: '瀚林愿AI成长平台，专注学生体质、心理、学情与行为数据智能分析，构建校园全场景AI数字孪生体系，助力学校精准育人与区域教育科学决策，赋能教育数字化转型。',
  keywords: 'AI成长平台 、校园安全、瀚易特、瀚林愿',
  url: 'index',
})

// 结构化数据
useHead({
  script: [
    {
      type: 'application/ld+json',
      innerHTML: JSON.stringify({
        '@context': 'https://www.hanit.cn',
        '@type': '官网',
        name: '瀚易特信息技术股份有限公司',
        description: '瀚林愿AI成长平台，专注学生体质、心理、学情与行为数据智能分析，构建校园全场景AI数字孪生体系，助力学校精准育人与区域教育科学决策，赋能教育数字化转型。',
        url: 'https://www.hanit.cn'
      })
    }
  ]
})

const { getHomeNewsApi, getCaseListApi, getPlatformIntroductionApi } = useHttpApi()

const activeItem = ref(0)
const caseActiveIndex = ref(0)

const caseList = ref([])

const newsData = ref([
  {
    title: '政策动态',
    enTitle: 'Policy dynamics',
    bgColor: 'blue',
    icon: '',
    type: '2',
    list: []
  },
  {
    title: '公司动态',
    enTitle: 'Company dynamics',
    bgColor: 'yellow',
    icon: '',
    type: '0',
    list: []
  },
  {
    title: '产品动态',
    enTitle: 'Product dynamics',
    bgColor: 'green',
    icon: '',
    type: '1',
    list: []
  }
])

// 获取平台介绍
const platformIntroduction = ref({} as any)
const fileObj = ref({
  fileUrl: '',
  fileType: ''
})
const getPlatformIntro = async () => {
  const res = await getPlatformIntroductionApi()
  platformIntroduction.value = res?.data?.data || {}
  fileObj.value.fileUrl = platformIntroduction.value.contentList[0].fileUrl || ''
  fileObj.value.fileType = platformIntroduction.value.contentList[0].fileUrl.slice(-3) === 'mp4' ? 'video' : 'img'
}

const handleActiveItem = (index: number) => {
  activeItem.value = index
  fileObj.value.fileUrl = platformIntroduction.value.contentList[index].fileUrl || ''
  fileObj.value.fileType = platformIntroduction.value.contentList[index].fileUrl.slice(-3) === 'mp4' ? 'video' : 'img'
}

// 获取案例
const bgColorList = ['blue','yellow','green','red']
const caseIconList = [caseIcon01,caseIcon02,caseIcon03,caseIcon04]
const getCaseList = async () => {
  const res = await getCaseListApi(true)
  caseList.value = res?.data?.data.slice(0,4)
  caseList.value.map((item,index) => {
    item.bgColor = bgColorList[index]
    item.icon = caseIconList[index]
  })
}

// 获取新闻
const getNews = async () => {
  const res = await getHomeNewsApi()
  const data = res?.data?.data
  newsData.value[0].list = data['2']
  newsData.value[1].list = data['0']
  newsData.value[2].list = data['1']
}

onMounted(() => {
  getPlatformIntro()
  getCaseList()
  getNews()
})

//通过接口获取数据
// const { data: products } = useFetchData('http://sample.hanit.cn/admin-api/hly/school-year/list',{method: 'post'})
// console.log(products)
</script>

<style scoped lang="scss">
@use "sass:color";
@use "~~/assets/scss/main.scss" as *;

.home {
  min-height: 100vh;
}

.main-content {
  padding: 30px 0;
  .title {
    // font-family: myFont;
    text-align: center;
    margin-bottom: 20px;
    .small-text {
      font-size: 12px;
      color: rgba($color: #000000, $alpha: 0.3);
      text-transform: uppercase;
    }
  }
}

.about {
  display: flex;
  gap: 20px;
  padding: 15px 0;

  .about-left {
    width: 210px;
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
    gap: 10px;
    background: #fff;
    padding: 20px;
    border-radius: 10px;

    .about-item {
      background: #F4F9FF;
      padding: 20px;
      border-radius: 10px;
      cursor: pointer;
      font-size: 16px;
      font-weight: 400;
      color: #5B5F7C;
      text-align: center;
      transition: all 0.3s ease;
      &.active {
        background: #5E73FC;
        color: #fff;
        font-weight: 700;
      }
    }
  }

  .about-right {
    flex: 1;
    background: #fff;
    padding: 20px;
    border-radius: 10px;

    .about-img {
      width: 100%;
      // height: 100%;
      object-fit: cover;
    }
    .about-content {
      min-height: 300px;
    }
  }
}

.about-col {
  .container {
    max-width: 100%;
    padding: 0;
  }
  .about {
    flex-direction: column;
    padding: 0;
  }
  .about-left {
    width: 100%;
    flex-direction: row;
    justify-content: center;
    background: none;
    padding: 0;
    background: #fff;
    border-bottom: solid 1px #EBF2FC;
    gap: 40px;
    .about-item {
      position: relative;
      background: none;
      padding: 10px 20px;
      transition: none;
      font-size: 18px;
      &::after {
        content: '';
        width: 100%;
        height: 3px;
        background: transparent;
        position: absolute;
        bottom: 0;
        left: 0;
        border-radius: 10px;
        // transition: all 0.3s ease;
      }
      &.active {
        background: none;
        color: #5E73FC;
        font-weight: 500;
        &::after {
          background: #5E73FC;
        }
      }
    }
  }
  .about-right {
    width: 1200px;
    margin: 0% auto;
  }
}

.case-list {
  display: flex;
  // justify-content: space-between;
  gap: 20px;

  .case-item {
    width: 160px;
    height: 400px;
    overflow: hidden;
    border-radius: 20px;
    position: relative;
    transition: all 0.3s ease;
    color: #fff;
    font-size: 18px;
    font-weight: 500;
    &.active {
      width: 690px;
    }
    .case-img {
      width: 690px;
      height: 100%;
      object-fit: cover;
    }
    .case-content {
      width: 160px;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      cursor: pointer;

      &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: #5E73FC;
        // opacity: 0.9;
        transition: all 0.3s ease;
      }
      &:hover {
        &::before {
          opacity: 1;
        }
        .case-content-main {
          transform: translateY(-20px);
        }
      }
      &.blue {
        &::before {
          // background: #5E73FC;
          background: linear-gradient(180deg, rgba(94, 115, 252, 1) 0%, rgba(94, 115, 252, 1) 30%, rgba(94, 115, 252, 0.8) 100%);
        }
      }
      &.yellow {
        &::before {
          // background: #FFBC37;
          background: linear-gradient(180deg, rgba(255, 188, 55, 1) 0%, rgba(255, 188, 55, 1) 30%, rgba(255, 188, 55, 0.8) 100%);
        }
      }
      &.green {
        &::before {
          // background: #21CA7E;
          background: linear-gradient(180deg, rgba(33, 202, 126, 1) 0%, rgba(33, 202, 126, 1) 30%, rgba(33, 202, 126, 0.8) 100%);
        }
      }
      &.red {
        &::before {
          // background: #FF804E;
          background: linear-gradient(180deg, rgba(255, 128, 78, 1) 0%, rgba(255, 128, 78, 1) 30%, rgba(255, 128, 78, 0.8) 100%);
        }
      }
      .case-content-main {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
        padding: 80px 10px;
        text-align: center;
        transition: all 0.3s ease;
        
        .case-icon {
          width: 84px;
          height: 84px;
        }
        .case-name {
          font-weight: 500;
        }
        .case-more-btn {
          display: inline-block;
          color: #fff;
          cursor: pointer;
          background: rgba(255, 255, 255, 0.3);
          padding: 2px 15px;
          border-radius: 50px;
          line-height: 1;
        }
      }
    }
  }
}

.news {
  display: flex;
  justify-content: space-between;

  .news-item-box {
    width: 378px;
    // height: 374px;
    padding: 20px;
    border-radius: 20px;
    color: #3A3F60;
    background: #fff;
    border-radius: 10px;
    transition: all 0.3s ease-in-out;
    &:hover {
      transform: translateY(-5px);
      box-shadow: 0 2px 4px rgba(0,0,0,0.1);
    }

    .news-type {
      height: 120px;
      border-radius: 10px;
      background: #E3F1FF;
      color: #fff;
      padding-left: 20px;
      margin-bottom: 20px;
      &.blue {
        background: url('@/assets/images/news/icon01.png') no-repeat, #6C6FFF;
        background-size: 120px 120px;
        background-position: right center;
      }
      &.yellow {
        background: url('@/assets/images/news/icon02.png') no-repeat, #ECB94B;
        background-size: 120px 120px;
        background-position: right center;
      }
      &.green {
        background: url('@/assets/images/news/icon03.png') no-repeat, #29C78B;
        background-size: 120px 120px;
        background-position: right center;
      }
      .news-type-left {
        display: flex;
        flex-direction: column;
        justify-content: center;
        height: 100%;
        .news-type-title {
          font-size: 24px;
          font-weight: 700;
        }
        .news-type-enTitle {
          font-size: 16px;
          color: rgba(255,255,255,0.6);
          font-weight: 500;
          text-transform: uppercase;
        }
      }
    }

    .news-list {
      display: flex;
      flex-direction: column;
      gap: 10px;
      .news-item {
        display: flex;
        gap: 10px;
        font-size: 16px;

        .news-time {
          color: rgba(58,63,96,0.5);
        }
        .news-title {
          flex: 1;
          color: #3A3F60;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          cursor: pointer;
          transition: all 0.3s ease-in-out;
          &:hover {
            color: $primary-color;
          }
        }
      }
    }
    .news-more {
      text-align: right;
      margin-top: 30px;
      .news-more-btn {
        display: inline-block;
        color: #757EBB;
        cursor: pointer;
        background: #F1F3FF;
        padding: 2px 15px;
        border-radius: 50px;
        line-height: 1;
        transition: all 0.3s ease-in-out;
        &:hover {
          background: #E3F1FF;
        }
      }
    }
  }
}


</style>